// src/tour/useTour.js
import { useContext } from 'react'
import { TourContext } from './TourContext'

/**
 * Access the tour engine.
 * @returns {{ state: object, actions: object }}
 *   state.activeTourId, state.activeScript, state.currentStep, state.currentStepIndex,
 *   state.totalSteps, state.visitedStepIds, state.isPaused, state.homeContext
 *   actions.startTour(tourId, homeId), nextStep, previousStep, skipStep,
 *   skipTour(reason), remindLater, completeTour, enterOptionalBranch(id),
 *   exitOptionalBranch, dispatchAction(name, payload), track(eventType, extra)
 */
export function useTour() {
  const ctx = useContext(TourContext)
  if (!ctx) {
    throw new Error('useTour must be used within a <TourProvider>')
  }
  return ctx
}
